import React, { useEffect, useState } from "react";
import { ResponsiveBar } from "@nivo/bar";
import { Col, Row } from "antd";

const keys = ["Total", "Completed"];
const colors = ["#172657", "#e21c21"];

const HoursBySalesRepAndActivityGraph = ({ data }) => {
  const [graphData, setGraphData] = useState([]);

  useEffect(() => {
    setGraphData(data);
  }, [data]);

  const ValueOutside = ({ bars }) => {
    return bars.map((bar) => {
      const {
        key,
        width,
        height,
        x,
        y,
        data: { value },
      } = bar;
      return (
        <g key={key} transform={`translate(${x + 10}, ${y})`}>
          <text
            transform={`translate(${width + 15}, ${height / 3 + 5})`}
            textAnchor="middle"
            fontSize="11px"
            fill="#757575"
          >
            {value}
          </text>
        </g>
      );
    });
  };

  const CustomBottomLabel = (data) => {
    const { x, value } = data;
    return (
      <g>
        <text x={x - 6 / 2} y={20} fontSize="12px" fill="#757575">
          {value}
        </text>
      </g>
    );
  };

  const getHeight = (length) => {
    if (length < 6) {
      return "500px";
    }
    return length * 100;
  };

  return (
    <Row>
      <Col span={1} className="left-axis-legend-col">
        <div>Document Type</div>
      </Col>
      <Col span={23}>
        <div style={{ maxHeight: "600px", overflowY: "scroll" }}>
          <div style={{ height: getHeight(graphData.length) }}>
            <ResponsiveBar
              data={graphData}
              keys={keys}
              indexBy="label"
              margin={{
                top: 20,
                right: 100,
                bottom: 100,
                left: 130,
              }}
              colors={colors}
              padding={0.3}
              groupMode="grouped"
              layout="horizontal"
              borderColor="inherit:darker(1.6)"
              enableLabel={false}
              enableGridX={true}
              enableGridY={false}
              theme={{
                axis: {
                  ticks: {
                    line: {
                      stroke: null,
                    },
                  },
                  domain: {
                    line: {
                      stroke: "",
                      strokeWidth: 2,
                    },
                  },
                  legend: {
                    text: {
                      fontWeight: "600",
                      // letterSpacing: "2px",
                      color: "#383838",
                      fill: "#383838",
                      fontSize: "13px",
                      fontFamily: "Open Sans",
                      lineHeight: "16px",
                    },
                  },
                },

                grid: {
                  line: {
                    stroke: `rgb(231 232 236 / 80%)`,
                    strokeWidth: 2,
                    strokeDasharray: "2, 4",
                  },
                },
              }}
              labelTextColor="white"
              layers={["grid", "axes", "bars", "markers", ValueOutside]}
              legends={[
                {
                  dataFrom: "keys",
                  // data: keys.map((id, index) => ({
                  //   color: colorsArray[index],
                  //   id,
                  //   //   label: id === "id" ? 1 : 2,
                  //   label: 1,
                  // })),
                  anchor: "bottom",
                  direction: "row",
                  translateY: 80,
                  itemWidth: 50,
                  itemHeight: 20,
                  itemDirection: "left-to-right",
                  symbolSize: 20,
                },
              ]}
              axisLeft={{
                format: (v) => {
                  return v.length > 22 ? (
                    <tspan>
                      {v.substring(0, 22) + "..."}
                      <title>{v}</title>
                    </tspan>
                  ) : (
                    v
                  );
                },
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: "",
                legendPosition: "middle",
                legendOffset: -100,
                // renderTick: CustomLeftLabel,
              }}
              axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: "Total and Completed",
                legendPosition: "middle",
                legendOffset: 50,
                renderTick: CustomBottomLabel,
                tickValues: 6,
              }}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default HoursBySalesRepAndActivityGraph;
